/** Checks if format is NNNNN. This does not check whether it's an actual psotal code in Sweden */
export const hasSwedishPostalCodeFormat = (value: string): boolean => {
  return regex.test(value);
};

/*
  The following regex pattern makes sure the string only contains the allowed characters

  ^ asserts position at start of the string
  \d matches a digit (equivalent to [0-9])
    {5} matches the previous token five times
  $ asserts position at the end of the string

 */
const regex = /^\d{5}$/;
